import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormFieldConfig, LegalTextConfig } from '../../../form-template-model';

@Component({
  selector: 'csi-form-template-legal-text-field-generator',
  templateUrl: './form-template-legal-text-field-generator.component.html',
  styleUrls: ['./form-template-legal-text-field-generator.component.css']
})
export class FormTemplateLegalTextFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: LegalTextConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  public safeContent: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    const content =
      (this.config && this.config.typeConfig && this.config.typeConfig.content) ||
      (this.config && this.config.label) ||
      '';
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
